import ServiceGraphQL from 'src/service/gql-service';
import { refund } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const Refund = (id) => {
  const params = {
    query: refund.QUERY,
    variables: {
      id
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res.data.invoiceRefund;
    })
    .catch((err) => {
      throw err;
    });
};
